import React from 'react';
import 'twin.macro';

interface Props {
  title: string;
  icon?: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
  footer: React.ReactNode;
}

export function SelectionResultPanel({
  title,
  icon: Icon,
  children,
  footer,
}: Props) {
  return (
    <div
      data-ai-toolbar
      tw="border border-neutral-quiet rounded-lg bg-white shadow-lg"
    >
      <div tw="bg-neutral-quiet py-2 px-4 flex items-center justify-between rounded-t-lg">
        <h5 tw="flex items-center text-base font-bold text-neutral-intense">
          {Icon && <Icon tw="h-5 w-5 mr-2" />}
          {title}
        </h5>
      </div>

      {children}

      <div tw="px-4 py-2 border-t border-neutral-quiet flex items-center justify-end gap-2">
        {footer}
      </div>
    </div>
  );
}
